(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.custom-tab');
  const contents = document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const targetId = this.getAttribute('data-content-id');

      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));

      this.classList.add('active');
      document.getElementById(targetId).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sectionEl = document.querySelector('[data-section-type="static-product"][data-section-data]');
  if (!sectionEl) return;

  let sectionData;
  try {
    sectionData = JSON.parse(sectionEl.textContent);
  } catch (e) {
    console.warn("Could not parse section data", e);
    return;
  }

  const handle = sectionData.product?.handle;
  if (!handle) return;

  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(liveProduct => {
      const currentVariantId = sectionData.product?.selected_or_first_available_variant?.id;
      const liveVariant = liveProduct.variants.find(v => v.id === currentVariantId);

      if (liveVariant && liveVariant.available) {
        const atcBtn = document.querySelector('[name="add"]') || document.querySelector('.product-form__submit');
        if (atcBtn) {
          atcBtn.classList.remove('disabled');
          atcBtn.disabled = false;
          atcBtn.textContent = sectionData.context.product_available || "Add to cart";
        }
      }
    })
    .catch(err => console.error("Error fetching live product data", err));
});

  } catch(e) { console.error(e); }
})();
})();
